import APIService from "./APIService";

const SafetyScoreAPI = {
  getUserSafetyScore: async () => {
    try {
      const response = await APIService.get(`/api/v1/app/safety-score/user`);
      console.log(`[SafetyScoreAPI] Get user safety score response:`, response);
      return response;
    } catch (error) {
      console.error("[SafetyScoreAPI] Error getting user safety score:", error);
      throw error;
    }
  },

  calculateUserSafetyScore: async () => {
    try {
      const response = await APIService.post(
        `/api/v1/app/safety-score/calculate`,
      );
      console.log(
        `[SafetyScoreAPI] Calculate user safety score response:`,
        response,
      );
      return response;
    } catch (error) {
      console.error(
        "[SafetyScoreAPI] Error calculating user safety score:",
        error,
      );
      throw error;
    }
  },
};

export default SafetyScoreAPI;
